import './AppRoot.css';
export var dtVisualRefreshDisabled = '_1jgl8s51-3-15-1';
export var dtVisualRefreshEnabled = '_1jgl8s50-3-15-1';